import axios from "axios";
import config from "../config";
import store from '../store/';

class CourseService {
  /**** Course APIs ****/

  getCourse() {
    return axios
      .get(config.API_URL + "/Courses/" + config.CourseId, {
        headers: { Authorization: "Bearer " + store.state.auth.user.accessToken }   
      })
      .then(response => {
        let data = response.data;
        return data;
      })
      .catch(error => {
        return Promise.reject(error); //console.log('An error occurred:', error.response);
      });
  }

  getModule(payload) {
    return axios
      .get(config.API_URL + "/Modules/" + payload, {
        headers: { Authorization: "Bearer " + store.state.auth.user.accessToken }   
      })
      .then(response => {
        let data = response.data;
        return data;
      })
      .catch(error => {
        return Promise.reject(error); //console.log('An error occurred:', error.response);
      });
  }

  /**** Progress APIs ****/

  getProgress(userId) {
    return axios
      .get(config.API_URL + "/Progresses?user=" + userId, {
        headers: { Authorization: "Bearer " + store.state.auth.user.accessToken }   
      })
      .then(response => {
        let data = response.data;
        return data;
      })
      .catch(error => {
        return Promise.reject(error); //console.log('An error occurred:', error.response);
      });
  }

  createProgress(payload) {
    return axios
      .post(config.API_URL + "/Progresses", payload, {
        headers: { Authorization: "Bearer " + store.state.auth.user.accessToken }   
      })
      .then(response => {
        let data = response.data;
        console.log("createProgress: ", data);
        return data;
      })
      .catch(error => {
        return Promise.reject(error); //console.log('An error occurred:', error.response);
      });
  }

  updateProgress(payload) {
    return axios
      .put(config.API_URL + "/Progresses/" + payload.id, payload, { 
        headers: { Authorization: "Bearer " + store.state.auth.user.accessToken }   
      })
      .then(response => {
        let data = response.data;
        console.log("Progress updated in dB: ", data);
        return data;
      })
      .catch(error => {
        return Promise.reject(error); //console.log('An error occurred:', error.response);
      });
  }
}

export default new CourseService();
